import { useState, useEffect } from 'react';

import { LayoutBaseDePagina } from "../../shared/layouts";
import { Environment } from '../../shared/environment';

import { Box, Card, CardContent, Grid, Typography, Icon, CircularProgress, Paper, Avatar, InputBase, IconButton, Tooltip, useTheme, Button, FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';

import jwt_decode from "jwt-decode";
import { TJwtToken } from '../../shared/services/api/usuario/auth/AuthService';
import { AlertSnackBar, AutoCompleteDeCliente, RangePicker } from '../../shared/components';
import { Doughnut, Line } from 'react-chartjs-2';
import { HomeService, IComparacaoSemanaAnterior, OPCOES_TIPO_ACAO, TipoAcao } from '../../shared/services/api/home/HomeService';
import { useAppThemeContext } from '../../shared/contexts';
import { useNavigate } from 'react-router-dom';
import { DatePicker } from '@mui/x-date-pickers';
import logo from '../../logo metiz.png';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { ArcElement } from 'chart.js';
import { Chart as ChartJS, Colors } from 'chart.js';
import { useDebounce } from '../../shared/hooks';

dayjs.extend(utc);

ChartJS.register(ArcElement);

export const Home = () => {
    const theme = useTheme();

    const [visao, setVisao] = useState("");
    const navigate = useNavigate();

    useEffect(() => {// toda vez que o token for mudado
        const token = localStorage.getItem("ACESS_TOKEN");
        if (token !== null) {// se tiver um token
            const decoded: TJwtToken = jwt_decode(token);
            setVisao(decoded.role);//seta a visão para não ter que recarregar a página
        }
    }, [localStorage.getItem("ACESS_TOKEN")]);

    const [pesquisaTextual, setPesquisaTextual] = useState<string>("");

    const [alert, setAlert] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
    const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);
    const [cnpj, setCnpj] = useState<string | undefined | null>(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const [rows, setRows] = useState<number[]>([]);
    const { toggleTheme, themeName } = useAppThemeContext();
    const [data, setData] = useState({
        labels: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
        datasets: [
            {
                label: ``,
                data: [0],
                backgroundColor: '',
                borderColor: '-1',
                tension: 0.4,
                pointStyle: '-1-',
                pointBorderColor: '-1',
                showLine: false,
            }
        ]
    });
    const [comparacaoSemanaAnterior, setComparacaoSemanaAnterior] = useState<IComparacaoSemanaAnterior>({ qtdeAtual: 0, diferencaPor: "0%" });

    const anoAtual = new Date().getFullYear();

    useEffect(() => {
        if (visao === "master" || visao === "clienteGestor") {
            setIsLoading(true);

            HomeService.gerarRelatorio(anoAtual, cnpj).then((result) => {

                if (result instanceof Error) {
                    setIsLoading(false);
                    setAlert({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlert(undefined);
                    }, duracaoAlert);
                } else {
                    setRows(result);
                }
            });

            HomeService.comparacaoSemanaAnterior(cnpj).then((result) => {
                setIsLoading(false);

                if (result instanceof Error) {
                    setComparacaoSemanaAnterior({ qtdeAtual: -1, diferencaPor: "0%", msgErro: result.message });
                } else {
                    setComparacaoSemanaAnterior(result);
                }
            });

        }
    }, [cnpj]);


    useEffect(() => {
        setData({
            labels: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
            datasets: [
                {
                    label: `${anoAtual}`,
                    data: rows,
                    backgroundColor: '#fbc02d',
                    borderColor: '#fbc02d',
                    tension: 0.4,
                    pointStyle: 'rect',
                    pointBorderColor: '#ff6600',
                    showLine: true
                }
            ]
        });
    }, [rows]);

    const [dataRelatorio, setDataRelatorio] = useState({ mes: "", ano: "" });
    const [erroDataRelatorio, setErroDataRelatorio] = useState(false);
    const [isLoadingDownloadRelatorio, setIsLoadingDownloadRelatorio] = useState(false);

    const handleClickDownloadRelatorioMensal = () => {

        if (dataRelatorio.mes === "" || dataRelatorio.ano === "") {
            setErroDataRelatorio(true);
        } else {
            setIsLoadingDownloadRelatorio(true);
            HomeService.downloadRelatorioMensal(dataRelatorio.mes, dataRelatorio.ano, cnpj).then((result) => {
                setIsLoadingDownloadRelatorio(false);

                if (result instanceof Error) {
                    setAlert({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlert(undefined);
                    }, duracaoAlert);
                }
            });
        }
    }

    const handleClickDownloadRelatorioMensalCaixas = () => {

        if (dataRelatorio.mes === "" || dataRelatorio.ano === "") {
            setErroDataRelatorio(true);
        } else {
            setIsLoadingDownloadRelatorio(true);
            HomeService.gerarRelatorioCaixaPorIntervalo(dataRelatorio.mes, dataRelatorio.ano, cnpj).then((result) => {
                setIsLoadingDownloadRelatorio(false);

                if (result instanceof Error) {
                    setAlert({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlert(undefined);
                    }, duracaoAlert);
                }
            });
        }
    }

    const handleClickDownloadRelatorio = () =>
    {
        setIsLoadingDownloadRelatorio(true);
        HomeService.downloadRelatorioGeral(cnpj).then((result) =>
        {
            setIsLoadingDownloadRelatorio(false);
            if (result instanceof Error) {
                setAlert({ tipoAlert: "erro", mensagem: result.message });
            } else {
                setAlert({ tipoAlert: "aviso", mensagem: result });
            }
            setTimeout(() => {
                setAlert(undefined);
            }, duracaoAlert);
        })
    }

    const handleClickDownloadRelatorioNaoIndexado = () =>
    {
        setIsLoadingDownloadRelatorio(true);
        HomeService.downloadRelatorioGeralNaoIndexado(localStorage.getItem("cnpj")).then((result) =>
        {
            setIsLoadingDownloadRelatorio(false);
            if (result instanceof Error) {
                setAlert({ tipoAlert: "erro", mensagem: result.message });
            } else {
                setAlert({ tipoAlert: "aviso", mensagem: result });
            }
            setTimeout(() => {
                setAlert(undefined);
            }, duracaoAlert);
        })
    }

    const handleClickDownloadRelatorioCaixas = () =>
    { 
        setIsLoadingDownloadRelatorio(true);
        HomeService.downloadRelatorioGeralCaixas(cnpj).then((result) => 
        {
            setIsLoadingDownloadRelatorio(false);   
            if (result instanceof Error) {
                setAlert({ tipoAlert: "erro", mensagem: result.message });
                setTimeout(() => {
                    setAlert(undefined);
                }, duracaoAlert);
            }
        })
    }

    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter') {
            handleClickDownloadRelatorioMensalCaixas();
            // handleClickDownloadRelatorioMensal();
        }
    };

    const [isLoadingDoughnut, setIsLoadingDoughnut] = useState(false);
    const [periodo, setPeriodo] = useState('');
    const [tipoAcao, setTipoAcao] = useState<TipoAcao | ''>('');
    const [dataDoughnut, setDataDoughnut] = useState({labels: [''], datasets: [{data: [0] , backgroundColor: [''], borderColor: ['']}], hoverOffset: 4})

    const formatarDataHoraUTC = (data: dayjs.Dayjs) => data.utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
    
    const options = {
        plugins: {
            legend: {
                labels: {
                    color: themeName === 'light' ? "" :'white', // Defina a cor da fonte da legenda
                },
            },
        },
      
    };
  
    function generateUniqueColors(numColors: number) {
      
      const uniqueColors: string[] = [];
  
      while (uniqueColors.length < numColors) {
        const newColor = randomColor();
  
        const colorExists = uniqueColors.some((color) => color === newColor);
  
        if (!colorExists) {
          uniqueColors.push(newColor);
        }
      }
  
      return uniqueColors;
    }
  
    function randomColor() {
      const r = Math.floor(Math.random() * 256);
      const g = Math.floor(Math.random() * 256);
      const b = Math.floor(Math.random() * 256);
  
      return `rgb(${r}, ${g}, ${b})`;
    }
  
    useEffect(()=>{
  
      setPeriodo(() => {
          return formatarDataHoraUTC(dayjs().startOf('day')) + ' | ' + formatarDataHoraUTC(dayjs().endOf('day'));
      });
    
  },[])
  
  const {debounce} = useDebounce();
  
  useEffect(()=>{
    debounce(()=>{
        setIsLoadingDoughnut(true);
        const dataInicial = periodo.split(' | ')[0];
        const dataFinal = periodo.split(' | ')[1];
        if(dayjs(dataInicial) !== null && dayjs(dataFinal) !== null){
    
        var cnpj = localStorage.getItem("cnpj");
        if(cnpj === null || cnpj === undefined) cnpj = "";
    
        HomeService.graficoUsuario(cnpj, dataInicial, dataFinal, tipoAcao).then((result) =>{
          setIsLoadingDoughnut(false);
  
            if(result instanceof Error){
                  setDataDoughnut({labels: ["Sem dados"], datasets: [{data: [1], backgroundColor: ['rgb(128, 128, 128)'], borderColor: new Array(1).fill(themeName === "light" ? "rgb(0, 0, 0)" : "rgb(256, 256, 256)")}], hoverOffset: 4})
            }else{
                  setDataDoughnut({labels: result?.nome?? [""], datasets: [{data: result?.qtde ?? [0], backgroundColor: generateUniqueColors(result?.nome.length ?? 0), borderColor: new Array(result?.nome.length).fill(themeName === "light" ? "rgb(0, 0, 0)" : "rgb(256, 256, 256)")}], hoverOffset: 4})
              }
        })
        }
    });

  },[periodo, cnpj, tipoAcao])

    function handleClickDownloadIndexados(): void 
    {
        setIsLoading(true);
        HomeService.downloadRelatorioIndexados(anoAtual, cnpj).then((result) => {
            setIsLoading(false);

            if (result instanceof Error) 
            {
                setAlert({ tipoAlert: "erro", mensagem: result.message });
                setTimeout(() => {
                    setAlert(undefined);
                }, duracaoAlert);
            }
            else
            {
                setAlert({ tipoAlert: "sucesso", mensagem: "Baixando relatório com sucesso" });
                setTimeout(() => {
                    setAlert(undefined);
                }, duracaoAlert);
            }
        });
    }

    function handleClickDownloadIndexadosPorUsuario(): void 
    {        
        setIsLoading(true);
        HomeService.downloadIndexadosPorUsuario(cnpj, periodo, tipoAcao).then((result) => {
            setIsLoading(false);

            if (result instanceof Error) 
            {
                setAlert({ tipoAlert: "erro", mensagem: result.message });
                setTimeout(() => {
                    setAlert(undefined);
                }, duracaoAlert);
            }
            else
            {
                setAlert({ tipoAlert: "sucesso", mensagem: "Download do relatório realizado com sucesso" });
                setTimeout(() => {
                    setAlert(undefined);
                }, duracaoAlert);
            }
        });
    }

    return (
        <LayoutBaseDePagina titulo="Página inicial" barraDeFerramentas={null}>

            {alert !== undefined && (
                <>
                    {alert.tipoAlert === "sucesso" && (
                        <AlertSnackBar gravidade="success" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                    {alert.tipoAlert === "erro" && (
                        <AlertSnackBar gravidade="error" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                    {alert.tipoAlert === "aviso" && (
                        <AlertSnackBar gravidade="warning" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                </>
            )}

            {(visao === "master" || visao === "clienteGestor") ? (
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                    <Grid container direction="column" alignItems={"center"} /*padding={5}*/ paddingBottom={5} spacing={2}>

                        <Box ml={2} mt={5} /*</Grid>width="30%"*/>
                            <AutoCompleteDeCliente selectedCnpj={selectedCnpj => setCnpj(selectedCnpj)} paraCadastro width={305}/>
                        </Box>

                        <Grid container item direction="column" alignContent={"center"}>

                                <Grid item xs={12} md={6}>
                                    <Box width="100%" display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                                        <Card sx={{ mt: 5, width: 305 }}>
                                            <CardContent>
                                                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                    Indexados
                                                </Typography>
                                                <Box padding={2} display='flex' flexDirection="column" justifyContent='center' alignItems='center'>
                                                    {isLoading ? (
                                                        <CircularProgress size={30} />
                                                    ) : comparacaoSemanaAnterior.qtdeAtual === -1 ? (
                                                        <Tooltip arrow title={comparacaoSemanaAnterior.msgErro}>
                                                            <Icon color='warning' sx={{ fontSize: 30 }}> warning </Icon>
                                                        </Tooltip>
                                                    ) : (
                                                        <>
                                                            <Typography variant='h2' align='center'>
                                                                <b> {comparacaoSemanaAnterior.qtdeAtual} </b>
                                                            </Typography>
                                                            <br />
                                                            <Typography variant='h4' align='center'
                                                                color={(comparacaoSemanaAnterior.diferencaPor).indexOf("-") === 0 ? "red" : "green"}>
                                                                <Icon> {(comparacaoSemanaAnterior.diferencaPor).indexOf("-") === 0 ? "arrow_downward" : "arrow_upward"} </Icon>
                                                                &nbsp;
                                                                {(comparacaoSemanaAnterior.diferencaPor).replace('-', '')}
                                                            </Typography>
                                                        </>
                                                    )}
                                                </Box>
                                                <Typography sx={{ fontSize: 10 }} color="text.secondary" gutterBottom>
                                                    Comparado à 7 dias atrás
                                                </Typography>

                                            </CardContent>
                                        </Card>

                                        <Box mt={5}
                                            onKeyDown={handleKeyDown}>
                                            <DatePicker
                                                label="Gerar Relatório do Mês"
                                                views={['month', 'year']}
                                                onChange={(newValue: Date | null) => {
                                                    setErroDataRelatorio(false)
                                                    setDataRelatorio({
                                                        //@ts-expect-error
                                                        mes: newValue?.format('MM'),
                                                        //@ts-expect-error
                                                        ano: newValue?.format('YYYY')
                                                    });
                                                }}

                                            />

                                            {isLoadingDownloadRelatorio ? (
                                                <CircularProgress sx={{ ml: 2, mt: 0.5 }} />
                                            ) : (
                                                <IconButton
                                                    sx={{ ml: 1, mt: 0.5 }}
                                                    size='large'
                                                    color={erroDataRelatorio ? 'error' : 'inherit'}
                                                    onClick={handleClickDownloadRelatorioMensalCaixas}
                                                >
                                                    <Tooltip arrow title="Baixar relatório">
                                                        <Icon>download</Icon>
                                                    </Tooltip>
                                                </IconButton>
                                            )}

                                        </Box>
                                    
                                    <br/>
                                        {/* <Box mt={5}
                                            onKeyDown={handleKeyDown}>
                                            <DatePicker
                                                label="Gerar relatório do mês"
                                                views={['month', 'year']}
                                                onChange={(newValue: Date | null) => {
                                                    setErroDataRelatorio(false)
                                                    setDataRelatorio({
                                                        //@ts-expect-error
                                                        mes: newValue?.format('MM'),
                                                        //@ts-expect-error
                                                        ano: newValue?.format('YYYY')
                                                    });
                                                }}

                                            />

                                            {isLoadingDownloadRelatorio ? (
                                                <CircularProgress sx={{ ml: 2, mt: 0.5 }} />
                                            ) : (
                                                <IconButton
                                                    sx={{ ml: 1, mt: 0.5 }}
                                                    size='large'
                                                    color={erroDataRelatorio ? 'error' : 'inherit'}
                                                    onClick={handleClickDownloadRelatorioMensal}
                                                >
                                                    <Tooltip arrow title="Baixar relatório">
                                                        <Icon>download</Icon>
                                                    </Tooltip>
                                                </IconButton>
                                            )}

                                        </Box>
                                    
                                    <br/> */}

                                    <Grid width={305} item>
                                        <Button
                                            variant="contained"
                                            disabled={isLoading}
                                            onClick={() => handleClickDownloadRelatorio()}
                                            size='large'
                                            fullWidth
                                            endIcon={isLoading ? <CircularProgress variant='indeterminate' color='inherit' size={20} /> : undefined}
                                        >
                                            Relatório de todos documentos indexados
                                        </Button>
                                    </Grid>

                                    <br/>

                                    <Grid width={305} item>
                                        <Button
                                            variant="contained"
                                            disabled={isLoading}
                                            onClick={() => handleClickDownloadRelatorioNaoIndexado()}
                                            size='large'
                                            fullWidth
                                            endIcon={isLoading ? <CircularProgress variant='indeterminate' color='inherit' size={20} /> : undefined}
                                        >
                                            Relatório de todos documentos não indexados
                                        </Button>
                                    </Grid>

                                    <br/>

                                    <Grid width={305} item>
                                        <Button
                                            variant="contained"
                                            disabled={isLoading}
                                            onClick={() => handleClickDownloadRelatorioCaixas()}
                                            size='large'
                                            fullWidth
                                            endIcon={isLoading ? <CircularProgress variant='indeterminate' color='inherit' size={20} /> : undefined}
                                        >
                                            Relatório de caixas cadastradas
                                        </Button>
                                    </Grid>

                                    </Box>
                                </Grid>


                                <Box component={Paper} mb = {5} mt = {5} width={"100vh"} display={"flex"}>
                                    <Grid container direction="column" alignItems="center" padding={5} spacing={2}>
                                    <Typography  variant='h5' > Documentos Indexados </Typography>
                                        <Grid item display="flex" padding={5} height={400} width="100%" justifyContent="center" >
                                                {isLoading ? (
                                                    <CircularProgress size={60} />
                                                ) : (
                                                    <Line data={data}   options={{
                                                        plugins: {
                                                            title: { display: true, color: themeName === 'light' ? "" : "RGB(229,229,229)" },
                                                            legend: {
                                                                labels: {
                                                                    color: themeName === 'light' ? "" : "RGB(229,229,229)"
                                                                }
                                                            }
                                                        },
                                                        scales: {
                                                            y: { suggestedMin: 0, suggestedMax: 10, ticks: { color: themeName === 'light' ? "" : "RGB(229,229,229)" }, grid: { color: themeName === 'light' ? "#f1f1f1" : "grey" } },
                                                            x: { ticks: { color: themeName === 'light' ? "" : "RGB(229,229,229)" }, grid: { color: themeName === 'light' ? "#f1f1f1" : "grey" } }
                                                        }
                                                    }} />
                                                )}
                                        </Grid>
                                        
                                        <Grid>
                                            <Button
                                                variant="contained"
                                                disabled={isLoading}
                                                onClick={() => handleClickDownloadIndexados()}
                                                size='small'
                                                fullWidth
                                                endIcon={isLoading ? <CircularProgress variant='indeterminate' color='inherit' size={20} /> : undefined}
                                            >
                                                <Icon>download</Icon>
                                            </Button>
                                        </Grid>

                                    </Grid>
                                </Box>



                            <Box component={Paper}>
                                <Grid container direction="column" alignItems="center" padding={5} spacing={2}>
                                    <Typography paddingBottom={4} variant='h5'> Documentos Indexados por Usuários </Typography>
                                    <Grid item display="flex" padding={5}>
                                        <RangePicker 
                                            labelInicial='Data inicial' 
                                            labelFinal='Data final'
                                            valueInicial={dayjs(periodo.split(' | ')[0])}
                                            valueFinal={dayjs(periodo.split(' | ')[1])}
                                            disabled={isLoadingDoughnut}

                                            retornoData={(dataInicial, dataFinal) => {

                                                if (dataInicial !== null && dataFinal !== null) {

                                                    setPeriodo(() => {
                                                        return formatarDataHoraUTC(dataInicial.startOf('day')) + ' | ' + formatarDataHoraUTC(dataFinal.endOf('day'));
                                                    });
                                                }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item display="flex" padding={5}>
                                        <FormControl fullWidth sx={{ minWidth: 220 }}>
                                            <InputLabel id="select-tipo-acao-label" shrink>Tipo de ação</InputLabel>
                                            <Select
                                                labelId="select-tipo-acao-label"
                                                id="select-tipo-acao"
                                                label="Tipo de ação"
                                                displayEmpty
                                                value={tipoAcao}
                                                disabled={isLoadingDoughnut}
                                                onChange={(event: SelectChangeEvent) => setTipoAcao(event.target.value as TipoAcao | '')}
                                            >
                                                <MenuItem value="">Todas</MenuItem>
                                                {OPCOES_TIPO_ACAO.map((opcao) => (
                                                    <MenuItem key={opcao.value} value={opcao.value}>{opcao.label}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item display="flex" alignItems="center" justifyContent="center" xs={12} md={6}>
                                        {isLoadingDoughnut ?
                                            
                                            <CircularProgress size={30} />
                                        
                                            :
                                        
                                            dataDoughnut && <Doughnut id='doughnut' data={dataDoughnut} options={options} />
                                        
                                        }
                                    </Grid>
                                </Grid>
                                <Grid  textAlign={"center"} mb={5}>
                                    <Button
                                        variant="contained"
                                        disabled={isLoading}
                                        onClick={() => handleClickDownloadIndexadosPorUsuario()}
                                        size='small'
                                        // fullWidth
                                        endIcon={isLoading ? <CircularProgress variant='indeterminate' color='inherit' size={20} /> : undefined}
                                    >
                                        <Icon>download</Icon>
                                    </Button>
                                </Grid>
                            </Box>

                        </Grid>

                    </Grid>
                </Box>
            ) :

                <Box margin={1} display="flex" component={Paper} variant="outlined">
                    <Grid height="70vh" container item justifyContent="center" flexDirection="column" alignItems="center" >

                        <Box width="100%" height={theme.spacing(16)} display="flex" alignItems="center" justifyContent="center">
                            <img src={logo} alt="" />
                        </Box>

                        <Paper
                            component="form"
                            sx={{ p: { md: '2px 4px', sm: '1px 2px' }, display: 'flex', alignItems: 'center', width: '36%', minWidth: 360, borderRadius: 8 }}
                        >
                            <InputBase
                                sx={{ flex: 1, fontSize: { md: 20, sm: 18 }, padding: 1 }}
                                placeholder="Pesquise documentos no Métiz"
                                inputProps={{ 'aria-label': 'Pesquisar documentos' }}
                                startAdornment={<Icon sx={{ mr: 1 }}> search </Icon>}
                                fullWidth
                                onKeyDown={(e) => { if (e.key == 'Enter') { localStorage.setItem("stringBusca", pesquisaTextual); navigate('/documento') } }}
                                onChange={(e) => { setPesquisaTextual(e.target.value) }}
                            />

                        </Paper>
                    </Grid>
                   
                </Box>
            }
        </LayoutBaseDePagina >
    );
}